module.exports = __webpack_public_path__ + "img/sales-rep.8cf36c25.jpg";